import { useSelectedHexGroupStore } from "@/store/selectedHexGroup";
import { usePriceRangesDataContext } from "@/store/PriceRangesProvider";
import { useTariffLayer } from "@/store/mode";
import { useMemo } from "react";

const DEFAULT_RANGE = {
  min: 100,
  max: 800,
};

export const useCurrentPriceRange = () => {
  const selectedHexGroup = useSelectedHexGroupStore((s) => s.selectedHexGroup);

  const { priceRanges, priceRangesLoading } = usePriceRangesDataContext();

  const tariffLayer = useTariffLayer((s) => s.getLayer());

  return useMemo(() => {
    if (
      priceRangesLoading ||
      !Array.isArray(priceRanges) ||
      priceRanges.length === 0 ||
      !selectedHexGroup?.id
    ) {
      return DEFAULT_RANGE;
    }

    const currentHexGroupRanges = priceRanges.find(
      (r) => r.id === selectedHexGroup?.id
    );

    const currentRange = currentHexGroupRanges?.ranges[tariffLayer];
    const rangeValid = currentRange?.min != null && currentRange?.max != null;

    return rangeValid ? currentRange : DEFAULT_RANGE;
  }, [priceRanges, priceRangesLoading, tariffLayer, selectedHexGroup]);
};
